




























































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Popup, Picker, Toast } from 'vant';
import Uploader from '@/components/next/NewUploader.vue';
import { isMobile, isWeiXin } from '@/common/ts/common';
import { register } from '../api';
import { unionIdIsBind } from '@/api/api';
Vue.use(Popup)
  .use(Picker)
  .use(Toast);

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

@Component({
  components: {
    Uploader,
  },
})
export default class Register extends Vue {
  name = '';
  phone = '';
  address = '';
  participants = '';
  introduction = '';
  isApp = false;
  saveChange = true;
  showMessage = false;
  clearcatch() {
    this.name = '';
    this.phone = '';
    this.address = '';
    this.participants = '';
    this.introduction = '';
  }

  async created() {
    if (isWeiXin() && !window.localStorage.getItem('unionid')) {
      this.WechatLogin();
    }
    this.checkIsBind();
  }

  WechatLogin() {
    if (isWeiXin()) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }

  closeSumbit(){
    this.showMessage = false;
  }

  async onSubmit() {
    if (isWeiXin() && !window.localStorage.getItem('unionid')) {
      this.WechatLogin();
    }
    this.checkIsBind();
    if (!this.name) {
      Toast('请输入姓名');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('请输入正确的手机号');
      return false;
    } else if (!this.address) {
      Toast('请输入活动地点');
      return false;
    } else {
      this.getSlideData();
    }
  }

  async checkIsBind() {
    const data = {
      type: 2,
      unionId: window.localStorage.getItem('unionid'),
    };
    if (window.udid) {
      this.AppLogin();
    } else if (isWeiXin()) {
      const res: any = await unionIdIsBind(data);
      if (!res.data) {
        this.$router.push(
            `/BindPhone?url=${encodeURIComponent(location.href)}`,
        );
        return false;
      } else {
          return true;
      }
    }
  }

  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
  async getSlideData() {
    if (!this.saveChange) {
      Toast('请勿重复提交！');
      return false;
    }
    this.saveChange = false;
    const data = {
      name: this.name,
      phone: this.phone,
      address: this.address,
      participants: this.participants,
      introduction: this.introduction,
      unionid: window.localStorage.getItem('unionid'),
      udid: window.udid,
      appkey: window.appkey,
      token: window.gettoken(),
    };
    const retRegister: any = await register(data);
    if (retRegister.code === 200) {
      this.showMessage = true;
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      Toast(retRegister.msg);
      if (retRegister.msg === '身份信息已过期！') {
        localStorage.removeItem('unionid');
        window.location.reload();
      }
    }
  }
}
